import { render, staticRenderFns } from "./jcTable.vue?vue&type=template&id=52b908a8&scoped=true&"
import script from "./jcTable.vue?vue&type=script&lang=js&"
export * from "./jcTable.vue?vue&type=script&lang=js&"
import style0 from "./jcTable.vue?vue&type=style&index=0&id=52b908a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b908a8",
  null
  
)

export default component.exports